"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _mapState = require("../hooks/mapState");
var _reactQuery = require("@tanstack/react-query");
var _layers = require("../hooks/queries/layers");
var _playback = require("../hooks/queries/playback");
var _lodash = _interopRequireWildcard(require("lodash"));
var _geoMap = _interopRequireDefault(require("./geo-map"));
var _TrainDrawer = _interopRequireDefault(require("./drawers/TrainDrawer"));
var _StationDrawer = _interopRequireDefault(require("./drawers/StationDrawer"));
var _toolbarButton = _interopRequireDefault(require("./components/toolbar-button"));
var _Scrubber = _interopRequireDefault(require("./components/Scrubber"));
var _map = require("./geo-map/map");
var _reactBootstrap = require("react-bootstrap");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var GEO_MAP = "geo-map";
var SYSTEM_MAP = "system-map";
var streetsURL = "https://api.maptiler.com/maps/streets-v2/tiles.json?key=".concat(_map.mapTilerAPIKey);
var satelliteURL = "https://api.maptiler.com/maps/satellite/tiles.json?key=".concat(_map.mapTilerAPIKey);
var basicURL = "https://api.maptiler.com/maps/basic-v2/tiles.json?key=".concat(_map.mapTilerAPIKey);
var winterURL = "https://api.maptiler.com/maps/winter-v2/tiles.json?key=".concat(_map.mapTilerAPIKey);
var topographicURL = "https://api.maptiler.com/maps/topo-v2/tiles.json?key=".concat(_map.mapTilerAPIKey);
var dataVizURL = "https://api.maptiler.com/maps/dataviz/tiles.json?key=".concat(_map.mapTilerAPIKey);
var backdropURL = "https://api.maptiler.com/maps/backdrop/tiles.json?key=".concat(_map.mapTilerAPIKey);
var customURL = "https://api.maptiler.com/maps/6ea2f294-0207-4ddd-9689-db566c8615ed/style.json?key=".concat(_map.mapTilerAPIKey);

// const URLObject = {
// 	'Streets': streetsURL,
// 	'Satellite': satelliteURL,
// 	'Basic': basicURL,
// 	'Winter': winterURL,
// 	'Topographic': topographicURL,
// 	'Data Viz': dataVizURL,
// 	'Backdrop': backdropURL,
// }

var layerOptions = [{
  name: 'Streets',
  value: streetsURL
}, {
  name: 'Satellite',
  value: satelliteURL
}, {
  name: 'Basic',
  value: basicURL
}, {
  name: 'Winter',
  value: winterURL
}, {
  name: 'Topographic',
  value: topographicURL
}, {
  name: 'Data Viz',
  value: dataVizURL
}, {
  name: 'Backdrop',
  value: backdropURL
}
// {
// 	name: 'Customized Example',
// 	value: customURL
// }
];

var KeolisMap = function KeolisMap(props) {
  var _mapState$auth, _mapState$auth2, _mapState$auth3, _mapState$auth4, _mapState$auth5, _mapState$auth6;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showLegend = _useState2[0],
    setShowLegend = _useState2[1];
  var _useMapState = (0, _mapState.useMapState)(),
    mapState = _useMapState.mapState,
    unselect = _useMapState.unselect,
    setTrains = _useMapState.setTrains;
  var selected = mapState.selected,
    playback = mapState.playback,
    trains = mapState.trains;
  var _getLineLayers = (0, _layers.getLineLayers)(mapState === null || mapState === void 0 ? void 0 : (_mapState$auth = mapState.auth) === null || _mapState$auth === void 0 ? void 0 : _mapState$auth.mapLayerToken),
    lineData = _getLineLayers.data;
  var _getStopsLayer = (0, _layers.getStopsLayer)(mapState === null || mapState === void 0 ? void 0 : (_mapState$auth2 = mapState.auth) === null || _mapState$auth2 === void 0 ? void 0 : _mapState$auth2.mapLayerToken),
    stopsData = _getStopsLayer.data;
  var _getFacilitiesLayer = (0, _layers.getFacilitiesLayer)(mapState === null || mapState === void 0 ? void 0 : (_mapState$auth3 = mapState.auth) === null || _mapState$auth3 === void 0 ? void 0 : _mapState$auth3.mapLayerToken),
    facilitiesData = _getFacilitiesLayer.data;
  var _getNonPublicStopsLay = (0, _layers.getNonPublicStopsLayer)(mapState === null || mapState === void 0 ? void 0 : (_mapState$auth4 = mapState.auth) === null || _mapState$auth4 === void 0 ? void 0 : _mapState$auth4.mapLayerToken),
    nonpublicStopsData = _getNonPublicStopsLay.data;
  var _getCrossingsLayer = (0, _layers.getCrossingsLayer)(mapState === null || mapState === void 0 ? void 0 : (_mapState$auth5 = mapState.auth) === null || _mapState$auth5 === void 0 ? void 0 : _mapState$auth5.mapLayerToken),
    crossingsData = _getCrossingsLayer.data;
  var _getTrainPositions = (0, _layers.getTrainPositions)(mapState === null || mapState === void 0 ? void 0 : (_mapState$auth6 = mapState.auth) === null || _mapState$auth6 === void 0 ? void 0 : _mapState$auth6.mapLayerToken),
    trainPositionData = _getTrainPositions.data;
  var _useState3 = (0, _react.useState)(basicURL),
    _useState4 = _slicedToArray(_useState3, 2),
    testLayer = _useState4[0],
    setTestLayer = _useState4[1];
  var mapRef = /*#__PURE__*/_react["default"].createRef(null);
  var handleResize = function handleResize() {
    mapRef.current.handleResize();
  };
  var getSelectedText = function getSelectedText() {
    var selected = mapState.selected;
    switch (selected.type) {
      case "train":
        var train = trainPositionData.features.find(function (t) {
          // console.log('in the find, ', t, t.id, selected.vehicleId)
          return t.properties.vehicleId === selected.entireTrainObj.vehicleId;
        });
        if (train) {
          // empty string here because these labels are huge if we include the route
          var properties = train.properties;
          var vehicle_status = properties.vehicle_status,
            vehicle = properties.vehicle,
            trip_short_name = properties.trip_short_name,
            operator = properties.operator;
          if (vehicle_status === 'GHOST') {
            return "Ghost trip ".concat(trip_short_name);
          }
          if (vehicle_status === 'UNTAGGED') {
            return "".concat(operator || '', " Vehicle ").concat(vehicle);
          }
          return "".concat(vehicle_status === 'REVENUE' ? 'Keolis Train ' : '').concat(trip_short_name);
        } else {
          return null;
        }
      case "milepost":
        var milepost = _lodash["default"].find(mileposts, function (m) {
          return m.milepostId == selected.id;
        });
        var location = _lodash["default"].find(locations, function (l) {
          return l.locationId == milepost.locationId;
        });
        return milepost ? milepost.fullname ? milepost.fullname : "".concat(location.name, ", Milepost ").concat(milepost.milepost, " ").concat(milepost.name ? " (" + milepost.name + ") " : "") : null;
      case "facility":
        var facility = _lodash["default"].find(facilitiesData.features, function (feat) {
          return feat.id == selected.id;
        });
        return facility ? "".concat(facility.properties.facility_long_name) : null;
      case "station":
        var stop = _lodash["default"].find(stopsData.features, function (feat) {
          return feat.id === selected.id;
        });
        var result = "".concat(stop.properties.stop_name);
        return result ? result : null;
      case "crossing":
        var crossing = _lodash["default"].find(crossingsData.features, function (feat) {
          return feat.id === selected.id;
        });
        return "".concat(crossing.properties.description);
      // case "route":
      // 	const line = _.find(locations, l => l.locationId == selected.id);
      // 	return line ? `${line.name}` : null;
      default:
        return null;
    }
  };
  var map = props.map,
    onToggleInfo = props.onToggleInfo,
    onToggleAllPages = props.onToggleAllPages,
    isKVL = props.isKVL,
    isMobile = props.isMobile;
  var selectedText = getSelectedText();
  (0, _react.useEffect)(function () {
    if (!playback.showScrubber && trainPositionData !== null && trainPositionData !== void 0 && trainPositionData.features) {
      setTrains(trainPositionData);
    }
  }, [trainPositionData, playback.showScrubber]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "standalone-map"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "panel-header md-blue"
  }, /*#__PURE__*/_react["default"].createElement("h2", null, "Map"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "icons"
  }, onToggleInfo && /*#__PURE__*/_react["default"].createElement(_toolbarButton["default"], {
    label: "Info",
    icon: _freeSolidSvgIcons.faInfoCircle,
    onClick: function onClick() {
      return onToggleInfo();
    }
  }), onToggleAllPages && /*#__PURE__*/_react["default"].createElement(_toolbarButton["default"], {
    label: "All Pages",
    icon: _freeSolidSvgIcons.faBullhorn,
    onClick: function onClick() {
      return onToggleAllPages();
    }
  }), /*#__PURE__*/_react["default"].createElement(_toolbarButton["default"], {
    label: "Legend",
    icon: _freeSolidSvgIcons.faCompass,
    onClick: function onClick() {
      return setShowLegend(!showLegend);
    }
  }))), /*#__PURE__*/_react["default"].createElement(_geoMap["default"], {
    ref: mapRef,
    showLegend: showLegend,
    newTrains: trains,
    stations: stopsData,
    nonpublicStops: nonpublicStopsData,
    lines: lineData,
    crossings: crossingsData,
    facilities: facilitiesData,
    setLayers: props.setLayers,
    enableTagging: mapState.auth.canTag,
    testLayer: testLayer
  }), isKVL && /*#__PURE__*/_react["default"].createElement(_Scrubber["default"], {
    unselect: unselect,
    selected: selected,
    selectedText: selectedText
  }));
};
var TaskButtonDefault = function TaskButtonDefault(_ref) {
  var task = _ref.task;
  return /*#__PURE__*/_react["default"].createElement("div", null, task.taskId);
};
var _default = KeolisMap;
exports["default"] = _default;